import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';

import { submitOtp, cancelOtp } from '../services/authBridge';

// Replaces the native prompt() for two-factor authentication. Opened by the
// HTTP interceptor (via authBridge) when a request returns `403 2fa-required`;
// the entered token is handed back to the awaiting request. If the code is
// rejected the interceptor re-prompts in place with a fresh `nonce` and the
// server's `error` message, so the user can retry without losing the action.
class OtpModal extends Component {
  state = { token: '', verifying: false };

  componentDidUpdate(prevProps) {
    // Each (re)prompt bumps the nonce — clear the field and re-enable submit,
    // whether this is the first prompt or a retry after a rejected code.
    if (prevProps.nonce !== this.props.nonce) {
      this.setState({ token: '', verifying: false });
    }
  }

  cancel = () => cancelOtp();

  submit = (e) => {
    if (e) e.preventDefault();
    const token = this.state.token.trim();
    if (!token || this.state.verifying) return;
    this.setState({ verifying: true });
    submitOtp(token);
  };

  render() {
    const { open, error } = this.props;
    const { token, verifying } = this.state;

    return (
      <Modal isOpen={!!open} toggle={this.cancel}>
        <ModalHeader toggle={this.cancel}>
          Two-factor authentication
        </ModalHeader>
        <Form onSubmit={this.submit}>
          <ModalBody>
            <p>
              Enter the code from your authenticator app to continue this
              action.
            </p>
            {error ? <Alert color="danger">{error}</Alert> : null}
            <FormGroup>
              <Label for="otp-token">Authentication code</Label>
              <Input
                id="otp-token"
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                maxLength={6}
                autoFocus
                placeholder="123456"
                value={token}
                disabled={verifying}
                onChange={(e) => this.setState({ token: e.target.value })}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" type="button" onClick={this.cancel}>
              Cancel
            </Button>{' '}
            <Button
              color="primary"
              type="submit"
              disabled={!token.trim() || verifying}
            >
              {verifying ? 'Verifying…' : 'Verify'}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    );
  }
}

export default connect((state) => ({
  open: state.modals.otp,
  error: state.modals.otpError,
  nonce: state.modals.otpNonce,
}))(OtpModal);
